exports = module.exports = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reports-filters .filters-panel{height:calc(100vh - 255px);max-height:600px;width:450px;top:44px}", ""]);
